var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rankings
    ? _c(
        "q-tabs",
        {
          staticClass: "fit",
          attrs: { swipeable: "" },
          on: { select: _vm.changeTab },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: { slot: "title", name: "t-all", label: _vm.$t("all") },
            slot: "title"
          }),
          _vm._l(_vm.user_firebase_document_ranking_areas, function(
            rank,
            index
          ) {
            return _c("q-tab", {
              key: "t-" + index,
              attrs: { slot: "title", name: "t-" + index, label: rank.area },
              slot: "title"
            })
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "t-all" } },
            [
              _c(
                "q-list",
                { attrs: { "no-border": "", separator: "", striped: "" } },
                _vm._l(_vm.filteredRanking, function(ranking, index) {
                  return _vm.filteredRanking.length > 0
                    ? _c(
                        "q-item",
                        { key: index },
                        [
                          _c(
                            "q-item-side",
                            {
                              attrs: {
                                color: ranking.i == _vm.id ? "black" : ""
                              }
                            },
                            [
                              ranking.i == _vm.id
                                ? _c("span", [
                                    _c("b", [_vm._v("# " + _vm._s(index + 1))])
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                           # " +
                                        _vm._s(index + 1) +
                                        "\n                        "
                                    )
                                  ])
                            ]
                          ),
                          _c(
                            "q-item-side",
                            { staticStyle: { width: "60px" } },
                            [
                              _c("img", {
                                staticClass: "round-avatar",
                                attrs: { src: _vm.getImage(ranking) },
                                on: { error: _vm.imageUrlAlt }
                              })
                            ]
                          ),
                          _c(
                            "q-item-side",
                            {
                              staticClass: "desktop-only",
                              attrs: {
                                color: ranking.i == _vm.id ? "black" : ""
                              }
                            },
                            [
                              ranking.i == _vm.id
                                ? _c("span", [
                                    _c("b", [_vm._v(_vm._s(ranking.n))])
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(ranking.n) +
                                        "\n                        "
                                    )
                                  ])
                            ]
                          ),
                          ranking.s
                            ? _c(
                                "q-item-main",
                                { staticClass: "text-right" },
                                [
                                  _c("q-item-tile", [
                                    _vm._v(_vm._s(_vm.getScore(ranking.s)))
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "q-item-main",
                                { staticClass: "text-right" },
                                [
                                  _c("q-item-tile", [
                                    _vm._v(_vm._s(_vm.getScore(0)))
                                  ])
                                ],
                                1
                              )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              ),
              _c(
                "q-inner-loading",
                { attrs: { visible: _vm.filteredRanking.length == 0 } },
                [
                  _c("q-spinner-dots", {
                    attrs: { size: 60, color: "secondary" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.user_firebase_document_ranking_areas, function(
            rank,
            index
          ) {
            return _c(
              "q-tab-pane",
              { key: "p-" + index, attrs: { name: "t-" + index } },
              [
                _c(
                  "q-list",
                  { attrs: { "no-border": "", separator: "", striped: "" } },
                  [
                    _vm._l(_vm.rankings, function(ranking, index) {
                      return _vm.rankings.length > 0
                        ? _c(
                            "q-item",
                            { key: index },
                            [
                              _c("q-item-side", [
                                _vm._v(
                                  "\n                        # " +
                                    _vm._s(index + 1) +
                                    "\n                    "
                                )
                              ]),
                              _c(
                                "q-item-side",
                                { staticStyle: { width: "60px" } },
                                [
                                  _c("img", {
                                    staticClass: "round-avatar",
                                    attrs: { src: _vm.getImage(ranking) },
                                    on: { error: _vm.imageUrlAlt }
                                  })
                                ]
                              ),
                              _c(
                                "q-item-side",
                                { staticClass: "desktop-only" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(ranking.full_name) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              ranking.score
                                ? _c(
                                    "q-item-main",
                                    { staticClass: "text-right" },
                                    [
                                      _c("q-item-tile", [
                                        _vm._v(
                                          _vm._s(_vm.getScore(ranking.score))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _c(
                                    "q-item-main",
                                    { staticClass: "text-right" },
                                    [
                                      _c("q-item-tile", [
                                        _vm._v(_vm._s(_vm.getScore(0)))
                                      ])
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    _c(
                      "q-item",
                      [
                        _c(
                          "q-inner-loading",
                          { attrs: { visible: _vm.rankings.length == 0 } },
                          [
                            _c("q-spinner-dots", {
                              attrs: { size: 60, color: "secondary" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm.rankings.length > 0 && _vm.has_next_page
                  ? _c("div", { staticClass: "row justify-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-4" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              label: _vm.$t("load_more"),
                              color: "tertiary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.loadRanking()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }